import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import moment from 'moment'

import { selectors as AppSelectors } from '../../redux/app/redux'
import { actions as TrackingActions } from '../../redux/tracking/redux'
import app from '../../config/app'
import routes, { Router } from '../../routes'
import { ArticleTypes } from '../../graphql/enums/articleType'

import ArticleDetail from './index'


// eslint-disable-next-line complexity
const ArticleDetailWrapper = (props) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const currentRoute = useSelector(AppSelectors.route)
  const {
    title,
    description,
    blocks,
    category,
    picture,
    credits,
    author,
    published_at,
    previous,
    next,
    linked_articles,
  } = props

  const trackShareEvent = (event) => dispatch(TrackingActions.trackEvent(event))
  const data = {
    category: {
      name: category.name,
      theme: ArticleTypes[category.theme],
      bgColor: category.bgColor,
    },
    title,
    description,
    image: picture,
    blocks,
    credits,
    author: {
      ...author,
      firstName: author.first_name,
      lastName: author.last_name,
    },
    share: {
      title: t('articleDetails_sharing_title'),
      twitterMessage: t('articleDetails_sharing_twitterMessage'),
      mailSubject: t('articleDetails_sharing_mailSubject'),
      mailBody: t('articleDetails_sharing_mailBody'),
      url: `${app.APP_URL}${currentRoute.asPath}`,
      trackEvent: trackShareEvent,
    },
    publishedAt: moment(published_at).format('DD.MM.YYYY'),
    previousPost: {
      link: previous ? Router.getRouteUrl(routes.article, { slug: previous.slug }) : null,
      title: previous ? previous.title : null,
    },
    nextPost: {
      link: next ? Router.getRouteUrl(routes.article, { slug: next.slug }) : null,
      title: next ? next.title : null,
    },
    textProps: {
      creditsLabel: t('articleDetails_credits_label'),
      authorLabelPortrait: t('articleDetails_author_label_portrait'),
      authorLabelDefault: t('articleDetails_author_label_default'),
      dateLabel: t('articleDetails_date_label'),
      previousPostLabel: t('articleDetails_previous_label'),
      nextPostLabel: t('articleDetails_next_label'),
      linkedPostsTitle: t('articleDetails_linked_posts_title'),
      downloadPdf: t('articleDetails_downloadPdf'),
    },
    ...linked_articles && linked_articles.length >= 1 && {
      linkedArticles: linked_articles.map((article) => ({
        title: article.title,
        description: article.description,
        image: article.picture,
        link: Router.getRouteUrl(routes.article, { slug: article.slug }),
        category: {
          name: category.name,
          theme: ArticleTypes[category.theme],
          bgColor: category.bgColor,
        },
      })),
    },
    ...(props.documentPdf && props.documentPdf.endsWith('.pdf') && {
      documentPdf: props?.documentPdf,
    }),
  }

  return <ArticleDetail {...data} />
}

ArticleDetailWrapper.propTypes = {
  ...ArticleDetail.propTypes,
}

export default ArticleDetailWrapper
